import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class QuotePurchaseEmailResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  get(supplierId, itemId, orgId, sendTogether = false) {
    const urlParams = !sendTogether
      ? objectToUrlParams({ item_id: itemId, ...(orgId && { organisation_id: orgId }) })
      : objectToUrlParams({ ...(orgId && { organisation_id: orgId }) });
    return super
      .get({ url: `${this.url}/${supplierId}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  send(data) {
    return super
      .post(data)
      .then((response) => response)
      .catch((error) => error.response);
  }
}
